module.exports = __webpack_public_path__ + "static/Song_Lyrics_Short_Version_with_Chords_G.7931d1e3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/Song_Lyrics_Short_Version_with_Chords_G.pdf
// module id = 344
// module chunks = 35783957827783